<template>
  <div class="product-skeleton">
    <div class="image-skeleton animate-pulse"></div>
    <div class="content-skeleton">
      <div class="title-skeleton animate-pulse"></div>
      <div class="price-skeleton animate-pulse"></div>
      <div class="button-skeleton animate-pulse"></div>
    </div>
  </div>
</template>

<style scoped>
.product-skeleton {
  background: var(--black-color-2);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 1rem;
  height: 100%;
}

.image-skeleton {
  width: 100%;
  height: 200px;
  background: var(--black-color-3);
  border-radius: 8px;
  margin-bottom: 1rem;
}

.content-skeleton {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.title-skeleton {
  height: 1.25rem;
  width: 80%;
  background: var(--black-color-3);
  border-radius: 4px;
}

.price-skeleton {
  height: 1.5rem;
  width: 60%;
  background: var(--black-color-3);
  border-radius: 4px;
}

.button-skeleton {
  height: 2.5rem;
  width: 100%;
  background: var(--black-color-3);
  border-radius: 8px;
  margin-top: 0.5rem;
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
